module.exports = __webpack_public_path__ + "img/Boredalis.bf6a4ffb.png";